import { router } from "@inertiajs/react"

import { StepHeader, WizardLayout } from "@/components/agents/setup/shell"
import type { SetupStepProps } from "@/components/agents/setup/types"
import { Button } from "@/components/ui/button"
import { setupAgentPath } from "@/routes"

import { STEP_ORDER, STEP_TITLE, type WizardStep } from "./steps"

interface PlaceholderStepProps extends SetupStepProps {
  step: WizardStep
}

export function PlaceholderStep({
  agent,
  step,
  stepNumber,
  totalSteps,
}: PlaceholderStepProps) {
  const prev = STEP_ORDER[STEP_ORDER.indexOf(step) - 1]

  function goBack() {
    if (!prev) return
    router.patch(setupAgentPath({ id: agent.uid }), { setup_step: prev })
  }

  return (
    <WizardLayout
      footer={
        prev ? (
          <Button variant="outline" onClick={goBack}>
            Back
          </Button>
        ) : undefined
      }
    >
      <StepHeader
        eyebrow={`Step ${stepNumber} of ${totalSteps}`}
        title={STEP_TITLE[step]}
        description="This step is still being built. Check back soon — your progress so far is saved."
      />
    </WizardLayout>
  )
}
